<template>
<div class="panel bgPanel mt1x pb1x h21x">
	<div class="title title-bg">
		<span :title="$t('word1578',['实时流动图'])">{{$t("word1578",["实时流动图"])}}</span>
	</div>
	<loading v-show="isLoading"></loading>
	<div class="pl5x pr5x">
		<div class="clearfix pl05x pr05x mb05x">
			<div class="fL tC dpIB_E">
				<svg class="w3x h3x pr05x"><use xlink:href="#ico-getPower"></use></svg>
				<div class="lh15">
					<span :title="getLanguageStr('word559','发电')">{{getLanguageStr('word559','发电')}}</span><br>
					<span class="cMain" :title="convertData(stationInfo.generationPower,2,'','W')[0]"><span class="fs14x">{{convertData(stationInfo.generationPower,2,"","W")[1]}}</span> {{convertData(stationInfo.generationPower,2,"","W")[2]}}</span>
				</div>
			</div>
			<div class="fR ">
				<svg class="w3x h3x"> <use xlink:href="#ico-eTower"></use> </svg>
				<div class="dpIB lh15" >
					<span :title="getLanguageStr('word560','电网')">{{getLanguageStr('word560','电网')}}</span><br>
					<span v-if="stationInfo.wirePower==null">--</span>
					<span v-else class="cMain" :title="convertData(stationInfo.wirePower,2,'','W')[0]"><span class="fs14x">{{convertData(Math.abs(stationInfo.wirePower),2,"","W")[1]}}</span> {{convertData(stationInfo.wirePower,2,"","W")[2]}}</span>
				</div>
			</div>
		</div>
		<div class="dpIB_E taC" ref="DashLines">
			<DashLine class="LDash mb05x" :dashLine="true" :viewWidth="DashWidth" :viewHeight="40" :isAnimation="false" :isArrow="false" :isColor="false"  v-if="stationInfo.generationPower ==null"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :viewWidth="DashWidth" :viewHeight="40" :isAnimation="false" :isArrow="false" v-else-if="stationInfo.generationPower==0"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :viewWidth="DashWidth" :viewHeight="40" v-else></DashLine>
			<svg class="w2x h2x vaB"><use xlink:href="#ico-ACDC"></use></svg>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'LT'" :isAnimation="true" :viewWidth="DashWidth" :viewHeight="40" v-if="stationInfo.wireStatus =='GRID_CONNECTED'"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'TL'" :isAnimation="true" :viewWidth="DashWidth" :viewHeight="40" v-if="stationInfo.wireStatus =='PURCHASE'"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'LT'" :isAnimation="false" :isColor="true" :viewWidth="DashWidth" :viewHeight="40" :isArrow="false" v-if="stationInfo.wireStatus =='STATIC'"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'LT'" :isAnimation="false" :isArrow="false" :isColor="false" :viewWidth="DashWidth" :viewHeight="40" v-if="stationInfo.wireStatus =='UNKNOWN'||stationInfo.wireStatus ==null"></DashLine>
		</div>
		<div class="taC mt05x dpIB_E">
			<DashLine class="LDash" :dashLine="false" :viewWidth="40" :directionLine="'TB'" :viewHeight="40" :isAnimation="false" :isArrow="false" :isColor="false" v-if="stationInfo.usePower ==null"></DashLine>
			<DashLine class="LDash" :dashLine="false" :viewWidth="40" :directionLine="'TB'" :viewHeight="40" :isAnimation="false" :isArrow="false" v-else-if="stationInfo.usePower==0"></DashLine>
			<DashLine class="LDash" :dashLine="false" :viewWidth="40" :directionLine="'TB'" :viewHeight="40"  v-else></DashLine>
		</div>
		<div  class="taC dpIB_E">
			<svg class="w3x h3x ml2x"><use xlink:href="#ico-house-useElectricity"></use></svg>
			<div class="taL lh15">
				<span :title="getLanguageStr('word561','用电')">{{getLanguageStr('word561','用电')}}</span><br>
				<span v-if="stationInfo.usePower==null">--</span>
				<span v-else class="cMain" :title="convertData(stationInfo.usePower,2,'','W')[0]"><span class="fs14x">{{convertData(Math.abs(stationInfo.usePower),2,"","W")[1]}}</span> {{convertData(stationInfo.usePower,2,"","W")[2]}}</span>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import DashLine from '@/components/common/ui/DashLine'

import * as lib from '@/util/lib.js'
export default {
	name: 'stationSummary',
	components: {Loading, DashLine},
	updated () {
		this.handleWinWidth()
	},
	data () {
		return {
			isShow: false,
			isLoading: false,
			stationInfo: {},
			DashWidth: 0
		}
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		show (data) {
			this.isShow = true
			if (data.stationInfo) {
				this.stationInfo = data.stationInfo
				setTimeout(() => {
					this.isLoading = false
				}, 500)
			}else {
				this._getList(data.stationId)
			}
			this.$set(this, 'DashWidth', parseInt(this.$refs.DashLines.clientWidth * 0.3))
		},
		handleWinWidth () {
			// window.onresize = () => {
			// 	return (() => {
			//         this.$set(this,"DashWidth",parseInt(this.$refs.DashLines.clientWidth*0.3))
			// 	})()
			// }
		},
		_getList (id) {
			this.isLoading = true
			equipmentApi.StationInfo(id).then(res => {
				this.stationInfo = res
				if (!res) {
					this.stationInfo = {}
					this.stationInfo.powerNetworkState = null
				}
				this.isLoading = false
			}, error => {
				this.isLoading = false
				!_.isEmpty(error) && this.$notify(error)
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/FlowChart.vue